import { adminPath, type AdminClient } from '../../modules/core/index.js'
import { readMarked, type Marked } from '../../modules/add-ons/index.js'
import { AI_USAGE_PATH } from './labels.js'
import type { AiOverview, ClientBriefingUsage } from './types.js'

/** The AI briefings' admin reads: a client's usage with where the add-on stands for it, and the deployment's overview. */
export interface AiBriefingsAdminApi {
  clientUsage(clientId: string, range?: { from: string; to: string }): Promise<Marked<ClientBriefingUsage>>
  overview(): Promise<AiOverview>
}

/** Built by the add-on's own screens from the client the registry hands them, as the add-on mounts its own routes on the API. */
export function createAiBriefingsAdminApi(client: AdminClient): AiBriefingsAdminApi {
  return {
    clientUsage: (clientId, range) => readMarked(client, `${adminPath.client(clientId)}/briefings${range ? `?from=${range.from}&to=${range.to}` : ''}`),
    overview: () => client.call('GET', AI_USAGE_PATH),
  }
}
